(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-list").innerHTML;
      theme.runMultiCurrency();
      $(window).trigger('checkcaptionheights');
      theme.checkForRevealElements();
      // Shopify reviews app
      if(window.SPR && SPR.initDomEls && SPR.loadBadges) {
        SPR.initDomEls();
        SPR.loadBadges();
      }
    }
  };
  request.send();
};
                                                      
                                                      
 function loadProductRecommendationsdeleteSection() {
      $(".product-list").html("<div></div>");
      $(".product_recom").css("display", "none");                                                
};
 
$( document ).ready(function() {

    loadProductRecommendationsIntoSection();   

    if(window.innerWidth > 600){
    $(".totol_description .product-description .real_des").css("display", "none");
	$(".totol_description .product-description table").css("display", "block");
  	$(".shipping_section").css("display", "none");
    $(".review_section").css("display", "none");
  	$(".payment_tab").css("display", "none");
  	$(".returns_section").css("display", "none");
    loadProductRecommendationsdeleteSection();  
  }
});
                                           

                                                      
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections#understand-the-interaction-between-theme-javascript-and-the-theme-editor
$(".title_group li").click(function() {
  if(window.innerWidth > 600){
    $(".title_group li").removeClass("active_title");
    $(this).addClass("active_title");
    var des_title= $(".active_title").text().trim();
	console.log(des_title)
  
  	if(des_title=="Other bought"){
        $(".totol_description").css("display", "none");
        $(".shipping_section").css("display", "none");
        $(".payment_tab").css("display", "none");
        $(".returns_section").css("display", "none");
        $(".review_section").css("display", "none");
        $(".product_recom").css("display", "block");       
        $("#shopify-section-product-recommendations .container").css("display", "flex");  
    	loadProductRecommendationsIntoSection();                   
    }
                                                      
    if(des_title=="Details"){
      $(".totol_description").css("display", "block");
      $(".totol_description .product-description").css("display", "block");
      $(".totol_description .product-description .real_des").css("display", "none");
      $(".totol_description .product-description table").css("display", "block");
      $(".shipping_section").css("display", "none");
      $(".review_section").css("display", "none");
      $(".payment_tab").css("display", "none");
      $(".returns_section").css("display", "none");
      loadProductRecommendationsdeleteSection();                                          
    }
    if(des_title=="Shipping" || des_title=="Versand" ){
                                                      console.log("sdf");
      loadProductRecommendationsdeleteSection();  
      $(".totol_description").css("display", "block");
      $(".totol_description .product-description").css("display", "none");
      $(".shipping_section").css("display", "block");
      $(".payment_tab").css("display", "none");
      $(".review_section").css("display", "none");
      $(".returns_section").css("display", "none");
    }
    if(des_title=="Returns"){
       loadProductRecommendationsdeleteSection(); 
      $(".totol_description").css("display", "block");
      $(".totol_description .product-description").css("display", "none");
      $(".shipping_section").css("display", "none");
      $(".payment_tab").css("display", "none");
      $(".review_section").css("display", "none");
      $(".returns_section").css("display", "block");
    }
    if(des_title=="Payments"){
       loadProductRecommendationsdeleteSection();  
      $(".totol_description").css("display", "block");
      $(".totol_description .product-description").css("display", "none");
      $(".shipping_section").css("display", "none");
      $(".payment_tab").css("display", "block");
      $(".review_section").css("display", "none");
      $(".returns_section").css("display", "none");
    }
    if(des_title=="Reviews(5.0)"){
       loadProductRecommendationsdeleteSection();  
      $(".totol_description").css("display", "none");
      $(".totol_description .product-description").css("display", "none");
      $(".shipping_section").css("display", "none");
      $(".payment_tab").css("display", "none");
      $(".review_section").css("display", "none");
      $(".review_section").css("display", "block");
      $(".returns_section").css("display", "none");
    }   
   }
});
// Fetching the recommendations on page load

                                                      
                                             

  } catch(e) { console.error(e); }
})();

})();
